import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Auth } from "aws-amplify";
import Footer from "../components/Footer";
import logo from "../logo.png";

import "../index.css";

import { Suspense } from "react";
import Waiting from "../components/Waiting";
import { API } from "aws-amplify";
import { permissionByUsername } from "../graphql/queries";
import wrapPromise from "../helpers/wrapPromise";

import UserContext from "../contexts/UserContext";


const components = {
  Header() {
    return (
      <div className="grid justify-items-center">
        <img
          src={logo}
          className="mt-10 mb-10 animate-bounce"
          style={{ height: "12rem" }}
          alt="Product Library"
          loading="lazy"
        />
      </div>
    );
  },
  Footer() {
    return <Footer/>;
  },
  SignIn: {
    Header() {
      return (
        <>
          <div className="grid ml-8 mr-8 justify-items-center">
            <h1 className="mt-5 mb-0 text-2xl font-bold">
              Product <span className="text-blue-700">Library</span>
            </h1>
            <div className="flex flex-row">
              <span className="font-bold text-blue-700">Find your product here!</span>{" "}
            </div>
            <button
              type="button"
              className="mt-8 w-full inline-block px-6 py-2.5 bg-blue-600 text-white text-2xs leading-normal font-bold rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              onClick={() => Auth.federatedSignIn()}
            >
              <span className="flex flex-row">
                <span className="w-12"></span>
                <span className="flex flex-row">
                  <span className="mr-2">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="windows"
                      className="w-5 h-5"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
                      ></path>
                    </svg>
                  </span>

                  <span>Sign in with Microsoft Outlook</span>
                </span>
                <span className="w-12"></span>
              </span>
            </button>
          </div>
          <hr className="mt-8 ml-8 mr-8" />
        </>
      );
    },
  },
};

const AuthLayout = ({ children }: { children: any }) => {
  const fetchPermission = (username: string) => {

    let permissionPromise = API.graphql({
      query: permissionByUsername,
      variables: { username: username ? username : "" },
    });
    
    return {
      permission: wrapPromise(permissionPromise),
    };
  };

  const Permission = ({ user, ps }: any) => {
    const permission = ps.permission.read();
    return (
      <UserContext.Provider value={{ user: { ...user, permission : {...permission} } }}>
        {children}
      </UserContext.Provider>
    );
  };

  return (
    
    <div className="relative min-h-screen BG-Pattern">
      <Authenticator hideSignUp={true} components={components}>
        {({ signOut, user }) => {
          const userGroups = user?.getSignInUserSession()?.getAccessToken().payload['cognito:groups'] || []
          const userInfo = {
            group: userGroups[0] || '',
            username: user?.username || '',
            givenName: user?.attributes?.given_name || '',
            name: user?.attributes?.name || '',
            familyName: user?.attributes?.family_name || '',
            email: user?.attributes?.email || '',
            phone_number: user?.attributes?.phone_number || '',
          }
          const ps = fetchPermission(userInfo.username!);

          return (
            <Suspense fallback={<Waiting />}>
              <Permission user={userInfo} ps={ps} />
            </Suspense>
          );
        }}
      </Authenticator>
    </div>
    
  );
};

export default AuthLayout;
